import React, { useEffect, useState } from 'react';
import { addToCart, getItems } from '../api';
import './ShopPages.css';

function CatalogPage() {
    const [items, setItems] = useState([]);
    const [brand, setBrand] = useState('');
    const [minPrice, setMinPrice] = useState('');
    const [maxPrice, setMaxPrice] = useState('');
    const [sort, setSort] = useState('');
    const [message, setMessage] = useState('');
    const [addingItemId, setAddingItemId] = useState(null);
    const token = localStorage.getItem('token');

    useEffect(() => {
        fetchItems();
        // eslint-disable-next-line
    }, []);

    const fetchItems = async () => {
        setMessage('');
        const params = {};
        if (brand) params.brand = brand;
        if (minPrice) params.min_price = minPrice;
        if (maxPrice) params.max_price = maxPrice;
        if (sort) params.sort = sort;

        const data = await getItems(params);
        setItems(data);
    };

    const handleFilter = () => {
        fetchItems();
    };

    const handleAddToCart = async (itemId) => {
        setMessage('');

        if (!token) {
            setMessage('Пожалуйста, войдите для добавления товаров в корзину.');
            return;
        }

        if (addingItemId !== null) {
            return;
        }

        setAddingItemId(itemId);

        try {
            const res = await addToCart(token, itemId);
            if (res.message === 'Item added to cart') {
                setMessage('Товар добавлен в корзину');
            } else {
                setMessage(res.message || 'Товар добавлен в корзину');
            }
        } finally {
            setAddingItemId(null);
        }
    };

    return (
        <div style={{ padding: '24px' }}>
            <div
                style={{
                    maxWidth: '1280px',
                    margin: '0 auto'
                }}
            >
                <div
                    style={{
                        background: 'linear-gradient(135deg, #ffffff 0%, #eef4ff 100%)',
                        borderRadius: '20px',
                        padding: '28px',
                        boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
                        marginBottom: '24px'
                    }}
                >
                    <h2 style={{ margin: '0 0 10px 0', fontSize: '2rem', color: '#111827' }}>Каталог товаров</h2>
                    <p style={{ margin: 0, color: '#6b7280', fontSize: '1rem' }}>
                        Выберите товары, добавьте их в корзину и оформите заказ.
                    </p>
                </div>

                <div
                    style={{
                        marginBottom: '20px',
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                        gap: '12px',
                        backgroundColor: '#ffffff',
                        padding: '18px',
                        borderRadius: '16px',
                        boxShadow: '0 8px 24px rgba(15, 23, 42, 0.06)'
                    }}
                >
                    <input
                        type="text"
                        placeholder="Бренд"
                        value={brand}
                        onChange={e => setBrand(e.target.value)}
                        style={{
                            padding: '12px 14px',
                            borderRadius: '10px',
                            border: '1px solid #d1d5db',
                            outline: 'none'
                        }}
                    />
                    <input
                        type="number"
                        placeholder="Мин. цена"
                        value={minPrice}
                        onChange={e => setMinPrice(e.target.value)}
                        style={{
                            padding: '12px 14px',
                            borderRadius: '10px',
                            border: '1px solid #d1d5db',
                            outline: 'none'
                        }}
                    />
                    <input
                        type="number"
                        placeholder="Макс. цена"
                        value={maxPrice}
                        onChange={e => setMaxPrice(e.target.value)}
                        style={{
                            padding: '12px 14px',
                            borderRadius: '10px',
                            border: '1px solid #d1d5db',
                            outline: 'none'
                        }}
                    />
                    <select
                        value={sort}
                        onChange={e => setSort(e.target.value)}
                        style={{
                            padding: '12px 14px',
                            borderRadius: '10px',
                            border: '1px solid #d1d5db',
                            outline: 'none',
                            backgroundColor: '#fff'
                        }}
                    >
                        <option value="">Без сортировки</option>
                        <option value="price_asc">Цена по возрастанию</option>
                        <option value="price_desc">Цена по убыванию</option>
                        <option value="name_asc">Название A-Я</option>
                        <option value="name_desc">Название Я-A</option>
                    </select>
                    <button
                        className="shop-btn-primary"
                        onClick={handleFilter}
                        style={{
                            padding: '12px 16px',
                            borderRadius: '10px'
                        }}
                    >
                        Применить
                    </button>
                </div>

                {message && (
                    <div
                        style={{
                            marginBottom: '18px',
                            color: '#065f46',
                            background: '#ecfdf5',
                            border: '1px solid #a7f3d0',
                            padding: '12px 14px',
                            borderRadius: '12px'
                        }}
                    >
                        {message}
                    </div>
                )}

                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
                        gap: '20px'
                    }}
                >
                    {items.map(item => (
                        <div
                            data-id={"item-card"}
                            key={item.id}
                            style={{
                                border: '1px solid #e5e7eb',
                                borderRadius: '18px',
                                overflow: 'hidden',
                                backgroundColor: '#fff',
                                boxShadow: '0 10px 24px rgba(15, 23, 42, 0.06)',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between'
                            }}
                        >
                            <div
                                style={{
                                    textAlign: 'center',
                                    padding: '18px',
                                    background: '#f9fafb',
                                    minHeight: '190px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {item.image_url && (
                                    <img
                                        src={item.image_url}
                                        alt={item.name}
                                        style={{
                                            maxWidth: '100%',
                                            maxHeight: '160px',
                                            objectFit: 'contain'
                                        }}
                                    />
                                )}
                            </div>

                            <div style={{ padding: '18px' }}>
                                <h3 style={{ margin: '0 0 8px 0', fontSize: '1.18rem', color: '#111827' }}>
                                    {item.name}
                                </h3>
                                <div
                                    style={{
                                        color: '#6b7280',
                                        marginBottom: '10px',
                                        fontSize: '0.95rem'
                                    }}
                                >
                                    Бренд: <strong style={{ color: '#374151' }}>{item.brand}</strong>
                                </div>
                                <div
                                    style={{
                                        fontSize: '1.2rem',
                                        fontWeight: 'bold',
                                        marginBottom: '10px',
                                        color: '#111827'
                                    }}
                                >
                                    {item.price} руб.
                                </div>
                                <p
                                    style={{
                                        fontSize: '0.92rem',
                                        color: '#6b7280',
                                        marginBottom: '0',
                                        lineHeight: '1.45'
                                    }}
                                >
                                    {item.description}
                                </p>
                            </div>

                            <div style={{ padding: '0 18px 18px 18px' }}>
                                <button
                                    className="shop-btn-primary"
                                    onClick={() => handleAddToCart(item.id)}
                                    disabled={addingItemId === item.id}
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        borderRadius: '12px',
                                        fontSize: '1rem'
                                    }}
                                >
                                    {addingItemId === item.id ? 'Добавление...' : 'Добавить в корзину'}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default CatalogPage;